import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthAndOnboardedGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      if (
        this.checkIsSurveyTaken(
          this.authService.currentUserValue["isSurveyTaken"]
        )
      ) {
        this.router.navigate(["/onboarding"], { replaceUrl: true });
      }

      return true;
    }

    this.router.navigate(["/auth/login"], {
      queryParams: { returnUrl: state.url },
      replaceUrl: true,
    });

    return false;
  }

  private checkIsSurveyTaken(isSurveyTaken?: boolean) {
    return isSurveyTaken === undefined || !isSurveyTaken;
  }
}
